import { render, staticRenderFns } from "./BerkleyPolicyDetail.vue?vue&type=template&id=2f232981"
import script from "./BerkleyPolicyDetail.vue?vue&type=script&lang=js"
export * from "./BerkleyPolicyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports